import React, { useState, useEffect } from 'react';     
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import { Link } from 'react-router-dom';
import printJS from 'print-js';
import AlertMessage from "../../AlertMessage";
import { Key } from '@mui/icons-material';

function PrelimsResult() {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({});

  const [attendance, setAttendance] = useState("");
const [remark, setRemark] = useState("");
const [dateOfIssue, setDateOfIssue] = useState("");

  // const [serialNoData, setSerialNoData] = useState({});
const [previousYearClass, setPreviousYearClass] = useState('');
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [examNames, setExamNames] = useState([
    "Prelim Exam-I",
    "Prelim Exam-II",
    "Prelim Exam-III",
    "Prelim Exam-IV",
    "Semester Second ",

    "Unit Test I",
    "Unit Test II",
     "Unit Test III",
    "Unit Test IV",
  ]);

  const examNameTranslations = {
    "Prelim Exam-I": "पूर्वपरीक्षा-1",
    "Prelim Exam-II": "पूर्वपरीक्षा-2",
    "Prelim Exam-III": "पूर्वपरीक्षा-3",
    "Prelim Exam-IV": "पूर्वपरीक्षा-4",
    "Semester Second ": "द्वितीय सत्र",
    "Unit Test I": "युनिट चाचणी-1",
    "Unit Test II": "युनिट चाचणी-2",
    "Unit Test III": "युनिट चाचणी-3",
    "Unit Test IV": "युनिट चाचणी-4",  
  };

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [subjectSequence, setSubjectSequence] = useState([]);
  const [selectedStudentForSr, setSelectedStudentForSr] = useState('');


  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
  const SCHOOL_STORE = 'schoolData';


  // Function to open IndexedDB
const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      // Create object stores if they don't exist
      if (!db.objectStoreNames.contains(STUDENT_STORE)) {
        db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
      }
      
      // Add SCHOOL_STORE if it doesn't exist
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students
  
      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();
  
        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });
  
        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };
  
      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  // Function to fetch student data from IndexedDB
  const fetchStudentData = async (db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();
  
      request.onsuccess = (event) => {
        const students = event.target.result;
        setStudentData(students);
  

        const classesAndDivisions = {};
        students.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }
            
            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }
            
            // Use the ID as the serial number equivalent
            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key
        const updatedStudents = students.map(student => {
          const keyParts = student.id.split("-"); // Split by "-"
          const className = keyParts[0]; // First part is class
          const division = keyParts[1]; // Second part is division
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo
          return { ...student, className, division, srNo };
        });
  
        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students
        resolve(updatedStudents);
      };
  
      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
        reject(event.target.error);
      };
    });
  };


  // Load student data and marks from IndexedDB
  useEffect(() => {
    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);

  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes
  
    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }
  };

const saveStudentDetails = async () => {
  if (!selectedStudentForSr) {
    setAlertMessage(language === "English" 
      ? "Please select a student first by clicking 'View Result'" 
      : "कृपया प्रथम 'प्रगति पत्रक' वर क्लिक करून विद्यार्थी निवडा");
    return;
  }

  try {
    const db = await openDB();
    const transaction = db.transaction(STUDENT_STORE, "readwrite");
    const store = transaction.objectStore(STUDENT_STORE);

    console.log('Saving details for student:', selectedStudentForSr.stdName, 'with ID:', selectedStudentForSr.id, 'and srNo:', selectedStudentForSr.srNo);

    // Get the specific student's record using their ID
    const request = store.get(selectedStudentForSr.id);
    
    request.onsuccess = async (event) => {
      const studentRecord = event.target.result;
      if (!studentRecord) {
        setAlertMessage(language === "English" 
          ? "Student record not found" 
          : "विद्यार्थ्याची नोंद सापडली नाही");
        return;
      }

      // Initialize the stdADR structure if it doesn't exist
      if (!studentRecord.stdADR) {
        studentRecord.stdADR = {};
      }
      if (!studentRecord.stdADR[academicYear]) {
        studentRecord.stdADR[academicYear] = {};
      }
      if (!studentRecord.stdADR[academicYear][selectedExamName]) {
        studentRecord.stdADR[academicYear][selectedExamName] = {};
      }

      // Update the attendance, remark, and date for this specific student
      studentRecord.stdADR[academicYear][selectedExamName] = {
        ...studentRecord.stdADR[academicYear][selectedExamName],
        attendance: attendance,
        remark: remark,
        date: dateOfIssue,
        srNo: selectedStudentForSr.srNo
      };

      console.log('Saving stdADR data for student:', selectedStudentForSr.stdName);
      console.log('Updated stdADR:', studentRecord.stdADR[academicYear][selectedExamName]);

      // Save the updated record to IndexedDB
      const updateRequest = store.put(studentRecord);
      
      updateRequest.onsuccess = async () => {
        try {
          // Update Firebase for this specific student
          const firebasePath = `schoolRegister/${udiseNumber}/studentData/${selectedStudentForSr.srNo}/stdADR/${academicYear}/${selectedExamName}`;
          
          const updates = {
            attendance: attendance,
            remark: remark,
            date: dateOfIssue,
            srNo: selectedStudentForSr.srNo
          };

          console.log('Updating Firebase path:', firebasePath);
          console.log('Firebase updates:', updates);

          const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/${firebasePath}.json`, {
            method: 'PATCH',
            body: JSON.stringify(updates),
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error('Failed to update Firebase');
          }

          // Update the selectedStudentResults to reflect the changes immediately in the modal
          if (selectedStudentResults) {
            setSelectedStudentResults(prev => ({
              ...prev,
              stdADR: {
                ...prev.stdADR,
                [academicYear]: {
                  ...prev.stdADR?.[academicYear],
                  [selectedExamName]: {
                    attendance: attendance,
                    remark: remark,
                    date: dateOfIssue,
                    srNo: selectedStudentForSr.srNo
                  }
                }
              }
            }));
          }

          setAlertMessage(language === "English" 
            ? `Details saved successfully for ${selectedStudentForSr.stdName}!` 
            : `${selectedStudentForSr.stdName} साठी तपशील यशस्वीरित्या जतन केले!`);
            
        } catch (firebaseError) {
          console.error("Firebase update error:", firebaseError);
          setAlertMessage(language === "English" 
            ? "Saved locally but failed to sync with server" 
            : "स्थानिक पातळीवर जतन केले परंतु सर्व्हरशी सिंक करणे अयशस्वी");
        }
      };
      
      updateRequest.onerror = (e) => {
        console.error("IndexedDB update error:", e.target.error);
        setAlertMessage(language === "English" 
          ? "Error saving details" 
          : "तपशील जतन करताना त्रुटी");
      };
    };
    
    request.onerror = (event) => {
      console.error("Error fetching student record:", event.target.error);
      setAlertMessage(language === "English" 
        ? "Error accessing student data" 
        : "विद्यार्थ्याचा डेटा मिळवताना त्रुटी");
    };

  } catch (error) {
    console.error("Error saving student details:", error);
    setAlertMessage(language === "English" 
      ? "Error saving details" 
      : "तपशील जतन करताना त्रुटी");
  }
};

  // Fetch marks data from IndexedDB when exam name changes
  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      const fetchMarks = async () => {
        try {
          const db = await openDB();
          const selectedStudents = studentData.filter(
            (student) => student.currentClass === classValue
          );
          setSelectedStudents(selectedStudents);
          const marksDataPromises = selectedStudents.map(async (student) => {
            const studentMarks = await fetchMarksData(db, student.srNo, academicYear, selectedExamName);
            return { srNo: student.srNo, marks: studentMarks };
          });

          const marksDataArray = await Promise.all(marksDataPromises);
          const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
            acc[srNo] = marks;
            return acc;
          }, {});

          setMarksData(marksData);
        } catch (error) {
          console.error('Error fetching marks data:', error);
        }
      };

      fetchMarks();
    }
  }, [selectedExamName, classValue, academicYear]);






  

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

 useEffect(() => {
  if (academicYear && (classValue || previousYearClass) && division) {
    fetchSubjectSequence();
  }
}, [academicYear, classValue, previousYearClass, division]);

const fetchSubjectSequence = async () => {
  try {
    const classToUse = previousYearClass || classValue;
    const divisionToUse = division;
    
    if (!academicYear || !classToUse || !divisionToUse) return;

    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classToUse}/${divisionToUse}.json`
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch subject sequence');
    }
    
    const data = await response.json();
    const orderedSubjects = Object.keys(data)
      .sort((a, b) => parseInt(a) - parseInt(b))
      .map((key) => data[key]);
    
    setSubjectSequence(orderedSubjects);
  } catch (error) {
    console.error('Error fetching subject sequence:', error);
    // Optionally set a default subject sequence or show an error message
    setSubjectSequence([]);
  }
};

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);


  

const fetchSchoolName = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, 'readonly');
    const store = transaction.objectStore(SCHOOL_STORE);
    
    // Get the school data using the udiseNumber as key
    const request = store.get(udiseNumber);

    request.onsuccess = (event) => {
      const schoolData = event.target.result;
      if (schoolData) {
        // Set school name and logo from IndexedDB
        setSchoolName(schoolData.schoolName || '-');
        setSchoolLogo(schoolData.schoolLogo || '');
        
        // Update language if available in school data
        if (schoolData.language) {
          setLanguage(schoolData.language);
          localStorage.setItem('language', schoolData.language);
        }
      } else {
        console.log('No school data found in IndexedDB');
        // Fallback to empty values if no data found
        setSchoolName('-');
        setSchoolLogo('');
      }
    };

    request.onerror = (event) => {
      console.error('Error fetching school data from IndexedDB:', event.target.error);
      // Fallback to empty values on error
      setSchoolName('-');
      setSchoolLogo('');
    };
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
    // Fallback to empty values on error
    setSchoolName('-');
    setSchoolLogo('');
  }
};

  useEffect(() => {
  fetchSchoolName();
}, [udiseNumber]); // Add udiseNumber as dependency

  useEffect(() => {
    if (selectedExamName && classValue && academicYear && division && selectedStudents.length > 0) {
      fetchMarksForSelectedStudents();
    }
  }, [selectedExamName, classValue, academicYear, division, selectedStudents]);

  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);



  const handleDivisionChange = (e) => {
    setDivision(e.target.value);
  };

  const handleExamNameChange = (e) => {
    setSelectedExamName(e.target.value);
  };

  const filteredExamNames = examNames.filter((examName) => examName === "Semester Second ");

  const fetchSubjectsForClassAndDivision = async (classValue, division) => {
    try {
      if (!classValue || !division || !academicYear) {
        console.error("Class, division, or academic year not set");
        return;
      }

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classValue}/${division}.json`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch subjects for class ${classValue} and division ${division}`);
      }
      const subjectsData = await response.json();
      if (subjectsData) {
        const validSubjects = Object.entries(subjectsData)
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([_, subject]) => subject);

        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: validSubjects,
          },
        }));
      } else {
        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: [],
          },
        }));
      }
    } catch (error) {
      console.error(`Error fetching subjects: ${error}`);
    }
  };

  useEffect(() => {
    if (classValue && division) {
      fetchSubjectsForClassAndDivision(classValue, division);
    }
  }, [classValue, division, academicYear]);

  const fetchMarksForSelectedStudents = async () => {
    try {
      const marksDataPromises = selectedStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });

      const marksDataArray = await Promise.all(marksDataPromises);
      const newMarksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});

      setMarksData(newMarksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };


  const fetchMarksData = async (key, academicYear, examName) => {
    try {
      console.log('Fetching Marks Data with:', { 
        key, 
        academicYear, 
        examName 
      });
  
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      
      const allKeys = await new Promise((resolve, reject) => {
        const keysRequest = store.getAllKeys();
        keysRequest.onsuccess = (event) => resolve(event.target.result);
        keysRequest.onerror = (event) => reject(event.target.error);
      });
  
      // Find the key that matches the numeric identifier
      const matchingKey = allKeys.find(storeKey => 
        typeof storeKey === 'string' && 
        storeKey.endsWith(`-${key}`)
      );
  
      console.log('Matching Key:', matchingKey);
  
      if (!matchingKey) {
        console.error('No matching key found for:', key);
        return {};
      }
  
      const request = store.get(matchingKey);
  
      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const studentData = event.target.result;
          
          console.log('Raw Student Data:', studentData);
  
          if (
            studentData && 
            studentData.icseResult && 
            studentData.icseResult[academicYear] && 
            studentData.icseResult[academicYear][examName]
          ) {
            const examMarks = studentData.icseResult[academicYear][examName];
            const result = {};
            
            // Handle subjects dynamically
            Object.keys(examMarks).forEach((subject) => {
              // Skip 'remark' key
              if (subject !== 'remark') {
                result[subject] = {
                  outOf: examMarks[subject].outOf,
                  obtainMarks: examMarks[subject].obtainMarks,
                  minMarks: examMarks[subject].minMarks,
                };
              }
            });
            
            console.log('Extracted Marks:', result);
            
            // Include remark if available
            if (examMarks.remark) {
              result.remark = examMarks.remark;
            }
            
            resolve(result);
          } else {
            console.warn('No marks found. Detailed Check:', {
              hasStudentData: !!studentData,
              hasIcseResult: studentData && !!studentData.icseResult,
              availableAcademicYears: studentData ? Object.keys(studentData.icseResult || {}) : 'No student data',
              availableExams: studentData && studentData.icseResult && studentData.icseResult[academicYear]
                ? Object.keys(studentData.icseResult[academicYear])
                : 'No exams found'
            });
            resolve({});
          }
        };
  
        request.onerror = (event) => {
          console.error("Error fetching marks from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchMarksData:', error);
      return {};
    }
  };
  
  const viewResult = async (key) => {
    try {
      console.log('Viewing Result for Key:', key);
  
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
  
      // Find all keys
      const allKeys = await new Promise((resolve, reject) => {
        const keysRequest = store.getAllKeys();
        keysRequest.onsuccess = (event) => resolve(event.target.result);
        keysRequest.onerror = (event) => reject(event.target.error);
      });
  
      // Find the matching key
      const matchingKey = allKeys.find(storeKey => 
        typeof storeKey === 'string' && 
        storeKey.endsWith(`-${key}`)
      );
  
      console.log('Matching Student Key:', matchingKey);
  
      if (!matchingKey) {
        console.error("Student not found for key:", key);
        setAlertMessage("Student not found. Please check the student details.");
        return;
      }
  
      // Fetch the student data
      const studentData = await new Promise((resolve, reject) => {
        const request = store.get(matchingKey);
        request.onsuccess = (event) => resolve(event.target.result);
        request.onerror = (event) => reject(event.target.error);
      });
  
      console.log('Found Student Data:', studentData);
  
      // Find student in selectedStudents
      const student = selectedStudents.find((s) => 
        s.rollNo === key ||
        s.registerNo === key ||
        s.serialNo === parseInt(key)
      );
      
      console.log('Found Student from Selected:', student);
      setSelectedStudentForSr(student);
  
      const marks = await fetchMarksData(key, academicYear, selectedExamName);
  
      console.log('Fetched Marks:', marks);
  
      if (marks && Object.keys(marks).length > 0) {

        const stdADR = studentData.stdADR?.[academicYear]?.[selectedExamName] || {};

      // Update state variables for modal input fields
      setAttendance(stdADR.attendance || '');
      setRemark(stdADR.remark || '');
      setDateOfIssue(stdADR.date || '');
      
        setSelectedStudentResults({
          studentName: studentData.stdName,
          results: marks,
          stdMother: studentData.stdMother,
          stdFather: studentData.stdFather,
          stdSurname: studentData.stdSurname,
          dob: studentData.dob,
          division: studentData.division,
          motherTounge: studentData.motherTounge,
          studentId: studentData.studentId,
          gender: studentData.gender,
          registerNo: studentData.registerNo,
          rollNo: studentData.rollNo,
          stdPhoto: studentData.stdPhoto,
          stdADR: studentData.stdADR || {}

        });
  
        setShowModal(true);
      } else {
        setAlertMessage(`No marks found for ${studentData.stdName}. Please add subjects and fill in the marks.`);
      }
    } catch (error) {
      console.error("Comprehensive Error in viewResult:", error);
      setAlertMessage("An unexpected error occurred. Please check console for details.");
    }
  };

  const calculateGradeEnglish = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Fail';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return 'अ-1';
    if (total >= 80) return 'अ-2';
    if (total >= 70) return 'ब-1';
    if (total >= 60) return 'ब-2';
    if (total >= 50) return 'क-1';
    if (total >= 40) return 'क-2';
    if (total >= 30) return 'ड-1';
    if (total >= 20) return 'ड-2';
    return 'नापास';
  };

  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };

  const handleCloseModal = () => setShowModal(false);

  const getPassingMarks = (currentClass) => {
    if (selectedStudentForSr.currentClass === "Class V" || selectedStudentForSr.currentClass === "इयत्ता पाचवी") {
      return 18;
    } else if (selectedStudentForSr.currentClass === "Class VIII" || selectedStudentForSr.currentClass === "इयत्ता आठवी") {
      return 21;
    }
    return 18;
  };

  const passingMarks = selectedStudentForSr ? getPassingMarks(selectedStudentForSr.currentClass) : 18;

  let totalSubjects = 0;
  let totalMarks = 0;
  let percentage = 0;

  if (selectedStudentResults && selectedStudentResults.results) {
    totalSubjects = Object.entries(selectedStudentResults.results)
      .filter(([subject]) => subject !== "nondi").length;

    totalMarks = Object.entries(selectedStudentResults.results)
      .filter(([subject]) => subject !== "nondi")
      .reduce((acc, [subject, grades]) => acc + (grades.sankalikTotal || 0) + (grades.akarikTotal || 0), 0);

    percentage = (totalMarks / (totalSubjects * 100)) * 100;
  }



  const handlePrint = async () => {
    try {
      const printContent = document.querySelector('.modal-body'); // Select the modal body content

      if (!printContent) {
        console.error('Print content not found');
        return;
      }

      // Clone the print content and apply styles
      const clone = printContent.cloneNode(true);

      // Apply scaling with increased size
      clone.style.padding = "10px"; // Add padding to balance scaling
      clone.style.margin = "0 auto"; // Center the content
      clone.style.transform = "scale(1.2)"; // Increase scale size
      clone.style.transformOrigin = "top center"; // Scale from the center-top
      clone.style.width = "fit-content"; // Ensure it doesn't overflow horizontally

      // Reset unnecessary styles to avoid blank space
      clone.querySelectorAll('p').forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      // Create a temporary container for the clone
      const printContainer = document.createElement("div");
      printContainer.style.margin = "0 auto"; // Center container
      printContainer.appendChild(clone);

      // Use printJS to print the content
      printJS({
        printable: printContainer.innerHTML,
        type: 'raw-html',
        style: `
                    @media print {
                        body { margin: 0; padding: 0; }
                        p { margin: 0; padding: 0; line-height: 1.4; }
    
     .table {
      width: 100%;
      border-collapse: collapse;
    }
    
    .table th, .table td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
      font-size: 12px
    }
    
    .table th {
      background-color: #f2f2f2;
      font-weight: bold;
        font-size: 12px
    }
    
    .table thead th {
      vertical-align: middle;
    }
    
    .table tbody td {
      vertical-align: middle;
    }
    
    .text-center {
      text-align: center;
    }
                        .school-info {
                            display: flex;
                            align-items: center;
                            margin-bottom: 20px;
                        }
                        .school-info img {
                            width: 100px;
                            height: 100px;
                            object-fit: cover;
                            margin-right: 20px;
                        }
                        .grad{
      position: absolute; /* add this */
      bottom: 25px; /* add this */
      left: 20px; /* add this */
      width: 90%; /* add this */
    }
                        @page {
                            margin: 0; /* Remove default page margins */
                        }
                    }
                `
      });
    } catch (error) {
      console.error('Error in handlePrint:', error);
    }
  };


const printAllResults = async () => {
  try {
    // Filter students by division and sort by rollNo
    const studentsToPrint = selectedStudents
      .filter((student) => student.division === division && student.isActive !== false)
      .sort((a, b) => a.rollNo - b.rollNo);

    if (studentsToPrint.length === 0) {
      setAlertMessage(language === "English" 
        ? "No students found to print" 
        : "प्रिंट करण्यासाठी विद्यार्थी सापडले नाहीत");
      return;
    }

    // Fetch all results data
    const allResults = await Promise.all(
      studentsToPrint.map(async (student) => {
        const results = await fetchMarksData(student.srNo, academicYear, selectedExamName);
        return {
          student,
          results
        };
      })
    );

    // Generate HTML for all results with the same styling as handlePrint
    const printContent = allResults.map(({ student, results }) => {
      const studentContent = document.createElement("div");
      studentContent.innerHTML = generateSingleResultHTML(student, results);
      
      // Apply the same styling as handlePrint
      studentContent.style.padding = "10px";
      studentContent.style.margin = "0 auto";
      studentContent.style.transform = "scale(1.2)";
      studentContent.style.transformOrigin = "top center";
      studentContent.style.width = "fit-content";
      
      // Reset unnecessary styles
      const paragraphs = studentContent.querySelectorAll('p');
      paragraphs.forEach(p => {
        p.style.margin = "0";
        p.style.padding = "0";
        p.style.lineHeight = "1.4";
      });

      return studentContent.outerHTML;
    }).join('<div style="page-break-after: always;"></div>');

    // Create a temporary container for all student results
    const printContainer = document.createElement("div");
    printContainer.style.margin = "0 auto";
    printContainer.innerHTML = printContent;

    // Use printJS with the same style as handlePrint
    printJS({
      printable: printContainer.innerHTML,
      type: 'raw-html',
      style: `
        @media print {
          body { margin: 0; padding: 0; }
          p { margin: 0; padding: 0; line-height: 1.4; }
          
          .table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .table th, .table td {
            border: 1px solid #000;
            padding: 8px;
            text-align: center;
            font-size: 12px;
          }
          
          .table th {
            background-color: #f2f2f2;
            font-weight: bold;
            font-size: 12px;
          }
          
          .table thead th {
            vertical-align: middle;
          }
          
          .table tbody td {
            vertical-align: middle;
          }
          
          .text-center {
            text-align: center;
          }
          
          .school-info {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
          }
          
          .school-info img {
            width: 100px;
            height: 100px;
            object-fit: cover;
            margin-right: 20px;
          }
          
          .grad {
            position: absolute;
            bottom: 25px;
            left: 20px;
            width: 90%;
          }
          
          @page {
            margin: 0;
          }
        }
      `
    });

  } catch (error) {
    console.error('Error printing all results:', error);
    setAlertMessage(language === "English" 
      ? "Error printing results" 
      : "निकाल प्रिंट करताना त्रुटी");
  }
};

const generateSingleResultHTML = (student, results) => {
  return `
    <div class="modal-body" style="width: 615px; height: 900px; margin: 0 auto; padding: 20px; border: 2px solid #000; box-sizing: border-box; overflow: hidden;">
      <div class="school-info">
        ${schoolLogo ? `<img src="${schoolLogo}" alt="Logo" style="width: 80px; height: auto; object-fit: contain; margin-right: 20px;" />` : ''}
        <h2>${schoolName}</h2>
      </div>

      <div>
        <hr style="width: calc(100% + 40px); height: 2px; background-color: black; border: none; margin-left: -20px; margin-right: -20px; margin-bottom: 6px;" />
        <b>
          <h6 style="text-align: center; margin: 0;">
            ${language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
          </h6>
          <h6 style="text-align: center; margin: 0;">
            ${language === "English" ? `${selectedExamName || '-'} EXAMINATION - ${academicYear}` : `प्रथम सत्र परीक्षा- ${academicYear}`}
          </h6>
        </b>
        <hr style="width: calc(100% + 40px); height: 2px; background-color: black; border: none; margin-left: -20px; margin-right: -20px; margin-top: 6px; margin-bottom: 6px;" />
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center; font-size: 14px;">
        <div style="flex: 1; text-align: left;">
          <label style="font-size: 14px;">${language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
          <span>${student.rollNo || '-'}</span>
        </div>
        <div style="flex: 1; text-align: center;">
          <label style="font-size: 14px;">${language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
          <span>${student.registerNo || '-'}</span>
        </div>
        <div style="flex: 1; text-align: right;">
          <label style="font-size: 14px;">${language === "English" ? "Class : " : "वर्ग : "}</label>
          <span>${classValue || '-'} ${student.division || '-'}</span>
        </div>
      </div>

      <hr style="width: calc(100% + 40px); height: 2px; background-color: black; border: none; margin-left: -20px; margin-right: -20px; margin-top: 1px" />

      <div style="font-size: 14px; margin-left: 30px; display: flex; justify-content: space-between; align-items: center;">
        <div style="width: 70%">
          <div>
            <label style="font-size: 14px;">${language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
            <span>${student.stdName || '-'} ${student.stdFather || '-'} ${student.stdSurname || '-'}</span>
          </div>
          <div>
            <label style="font-size: 14px;">${language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
            <span>${student.stdMother || '-'}</span>
          </div>
          <div>
            <label style="font-size: 14px;">${language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
            <span>${student.dob || '-'}</span>
          </div>
          <div>
            <label style="font-size: 14px;">${language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
            <span>${selectedExamName || '-'}</span>
          </div>
        </div>
        <div style="width: 30%">
          ${student.stdPhoto ? `<img src="${student.stdPhoto}" style="width: 80px; height: 80px;" />` : ''}
        </div>
      </div>

      ${results ? generateResultsTableHTML(results) : `
        <p style="font-size: 18px; text-align: center; margin-top: 20px; color: red;">
          ${language === "English" ? "! No result available please fill marks." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
        </p>
      `}

      ${results?.remark ? `
        <div style="margin-top: 10px;">
          <p>
            <strong>${language === "English" ? "Remark : " : "टिप्पणी : "}</strong>
            ${results.remark}
          </p>
        </div>
      ` : ''}

      <div class="grad" style="display: flex; justify-content: space-between; align-items: center; padding: 0 20px;">
        <label style="flex: 1; text-align: left; margin-bottom: 2px; margin-left: -10px;">
          ${language === "English" ? "Parent's signature" : "पालकांची सही"}
        </label>
        <label style="flex: 1; text-align: center; margin-bottom: 2px;">
          ${language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
        </label>
        <label style="flex: 1; text-align: right; margin-bottom: 2px; margin-right: 20px;">
          ${language === "English" ? "Principal" : "प्राचार्य"}
        </label>
      </div>
    </div>
  `;
};

const generateResultsTableHTML = (results) => {
  return `
    <table class="table table-striped table-bordered" style="font-size: 12px; padding: 5px;">
      <thead>
        <tr>
          <th rowspan="1" style="padding: 3px; color: black;">${language === "English" ? "Subject" : "विषय"}</th>
          <th style="padding: 4px; color: black;">${language === "English" ? "Max. Marks" : "पैकी"}</th>
          <th style="padding: 4px; color: black;">${language === "English" ? "Min. Marks" : "किमान गुण"}</th>
          <th style="padding: 4px; color: black;">${language === "English" ? "Obtain Marks" : "गुण"}</th>
          <th rowspan="1" style="padding: 3px; color: black;">${language === "English" ? "P %" : "%"}</th>
          <th rowspan="1" style="padding: 3px; color: black;">${language === "English" ? "Grade" : "श्रेणी"}</th>
        </tr>
      </thead>
      <tbody>
        ${subjectSequence
          .filter((subject) => {
            const grades = results[subject];
            return grades && grades.obtainMarks;
          })
          .map((subject) => {
            const grades = results[subject];
            const rowPercentage = grades.outOf > 0 
              ? ((grades.obtainMarks / grades.outOf) * 100).toFixed(2) 
              : "-";
            const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

            return `
              <tr key="${subject}" style="padding: 2px;">
                <td style="padding: 2px; color: black;">${subject}</td>
                <td style="padding: 2px; color: black;">${grades.outOf || "-"}</td>
                <td style="padding: 2px; color: black;">${grades.minMarks || "-"}</td>
                <td style="padding: 2px; color: black;">${grades.obtainMarks || "-"}</td>
                <td style="padding: 2px;"><b>${rowPercentage}</b></td>
                <td style="padding: 2px;"><b>${grade}</b></td>
              </tr>
            `;
          }).join('')}

        <tr>
          <td colspan="1" style="padding: 5px;">
            <b>${language === "English" ? "Total Marks" : "एकूण गुण"}</b>
          </td>
          <td colspan="1" style="padding: 5px;">
            <b>
              ${subjectSequence
                .filter(subject => results[subject]?.obtainMarks)
                .reduce((total, subject) => total + (results[subject].outOf || 0), 0)}
            </b>
          </td>
          <td colspan="1" style="padding: 5px;"></td>
          <td colspan="1" style="padding: 5px;">
            <b>
              ${subjectSequence
                .filter(subject => results[subject]?.obtainMarks)
                .reduce((total, subject) => total + (results[subject].obtainMarks || 0), 0)}
            </b>
          </td>
          <td style="padding: 5px;">
            <b>
              ${(() => {
                const filteredSubjects = subjectSequence.filter(subject => results[subject]?.obtainMarks);
                const totalMaxMarks = filteredSubjects.reduce((total, subject) => total + (results[subject].outOf || 0), 0);
                const totalObtainedMarks = filteredSubjects.reduce((total, subject) => total + (results[subject].obtainMarks || 0), 0);
                return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
              })()}
            </b>
          </td>
          <td style="padding: 5px;">
            <b>
              ${(() => {
                const filteredSubjects = subjectSequence.filter(subject => results[subject]?.obtainMarks);
                const totalMaxMarks = filteredSubjects.reduce((total, subject) => total + (results[subject].outOf || 0), 0);
                const totalObtainedMarks = filteredSubjects.reduce((total, subject) => total + (results[subject].obtainMarks || 0), 0);
                const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
              })()}
            </b>
          </td>
        </tr>
      </tbody>
    </table>
  `;
};

  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />


      <div className=' main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)', textAlign: 'center' }}> {language === "English" ? "ICSE Exam Result " : " ICSE परीक्षेचा निकाल"}</h3>
        <table className="table table-striped table-bordered">
          <tbody>
            <tr>
              <th style={{ width: 'calc(100% / 7)' }}> {language === "English" ? "Year " : "शैक्षणिक वर्ष  "}</th>
              <td>
                <select
                  id="academicYear"
                  defaultValue={academicYear} // Add this prop
                  value={academicYear}
                  onChange={handleAcademicYearChange}
                  className="form-control custom-select"
                >
                  <option >{language === "English" ? "Select Year " : "वर्ष निवडा "}</option>
                  <option value="2023-2024" >2023-2024</option>
                  <option value="2024-2025" selected>2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division " : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Division " : "तुकडी निवडा"}</option>
                  {divisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षा"}</th>
              <td>
                <select
                  id="examName"
                  value={selectedExamName}
                  onChange={handleExamNameChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Exam" : "परीक्षा निवडा"}</option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

                {/* Add this new row for previous year class selection */}
    {academicYear && academicYear !== "2025-2026" && (
      <tr>
        <th>{language === "English" ? "Previous Year Class" : "मागील वर्षाचा वर्ग"}</th>
        <td>
          <select
            value={previousYearClass}
            onChange={(e) => setPreviousYearClass(e.target.value)}
            className="form-control custom-select"
          >
            <option value="">{language === "English" ? "Select Class For Previous Result " : "मागील वर्षाचा वर्ग निवडा"}</option>
            {classes.map((cls, index) => (
              <option key={index} value={cls}>
                {cls}
              </option>
            ))}
          </select>
        </td>
      </tr>
    )}



          </tbody>
        </table>

        {selectedStudents.length > 0 && (
          <div className="mt-4">
          <div className="d-flex justify-content-between mb-3">
      <h4>{language === "English" ? "Student Results" : "विद्यार्थ्यांचे निकाल"}</h4>
      <button 
        className="btn btn-success"
        onClick={() => printAllResults()}
        disabled={!selectedExamName || !classValue || !division}
      >
        {language === "English" ? "Print All Results" : "सर्व निकाल प्रिंट करा"}
      </button>
    </div>
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">{language === "English" ? "Roll No " : "हजेरी क्र"}</th>
                  <th>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव"}</th>
                  <th>{language === "English" ? "icseResult " : "प्रगतीपत्रक"}</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents
          .filter((student) => student.division === division && student.isActive !== false)
                .sort((a, b) => a.rollNo - b.rollNo).map((student) => (
                  <tr key={student.srNo}>
                    <td>{student.rollNo}</td>
                    <td>{student.stdName} {student.stdSurname}</td>
                    <td>
                      <button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>
                        {language === "English" ? "View icseResult" : "प्रगति पत्रक"}
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
          <Modal.Header closeButton>
            <Modal.Title>{language === "English" ? "ICSE Exam icseResult " : "विद्यार्थ्यांचे निकाल"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedExamName === 'Second ' && selectedStudentResults ? (
              <div>



                {/* Semester Second  modal content */}
                <div className="r mt-1" style={{}}>

                </div>
              </div>




            ) : (
              <div>
                {/* Semester First  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>

                    <div className="school-info" >
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '80px', height: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      )}

                      <h2>{schoolName}</h2>
                    </div>

                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `${selectedExamName || '-'}  EXAMINATION - ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right' }}>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "Class : " : "वर्ग : "}
  </label>
  <span>
    {/* Show current class or previous year class if available */}
    {previousYearClass 
      ? `${previousYearClass}`
      : classValue || '-'}
    {/* Show division if available */}
    {selectedStudentResults?.division ? ` ${selectedStudentResults.division}` : ''}
  </span>
</div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
  <label htmlFor="class" style={{ fontSize: '14px' }}>
    {language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}
  </label>
  <span>
    {selectedStudentResults?.dob
      ? new Date(selectedStudentResults.dob).toLocaleDateString("en-GB") // dd-mm-yyyy
      : "-"}
  </span>
</div>

                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            <th style={{ padding: '4px', color: 'black' }}>{language === "English" ? "Max. Marks" : "पैकी"}</th>
                            <th style={{ padding: '4px', color: 'black'}}>{language === "English" ? "Min. Marks" : "किमान गुण"}</th>
                            <th style={{ padding: '4px', color: 'black'}}>{language === "English" ? "Obtain Marks" : "गुण"}</th>
                            <th rowSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "P %" : "%"}</th>
                            <th rowSpan="1" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Grade" : "श्रेणी"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults?.results?.[subject];
                                // Only include subjects where at least one of the grade fields has a valid value (not null or undefined)
                                return (
                                  grades && (
                                    grades.unitTestIObtainMarks ||
                                    grades.unitTestIIObtainMarks ||
                                    grades.obtainMarks)
                                );
                              })
                              .map((subject) => {
                                
                                const grades = selectedStudentResults?.results?.[subject];
                                // Calculate row-wise totals and percentage
                                const totalOutOf =

                                  (grades.outOf || 0);
                                const totalObtainMarks =

                                  (grades.obtainMarks || 0);
                                const rowPercentage =
                                  totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";
                                // Calculate grade based on the row percentage
                                const grade = rowPercentage !== "-" ? calculateGrade(Number(rowPercentage)) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      {subject}
                                    </td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.outOf || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.minMarks || "-"}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.obtainMarks || "-"}</td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{rowPercentage}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{grade}</b>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <>
                              <tr>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                
                                </td>
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence
                                      .filter(subject => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return grades.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0)}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                    })()}
                                  </b>
                                </td>
                                <td style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const filteredSubjects = subjectSequence.filter(subject => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return grades.obtainMarks;
                                      });
                                      const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.outOf || 0);
                                      }, 0);
                                      const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject] || {};
                                        return total + (grades.obtainMarks || 0);
                                      }, 0);
                                      const percentage = totalMaxMarks > 0 ? (totalObtainedMarks / totalMaxMarks) * 100 : 0;
                                      return language === 'English' ? calculateGradeEnglish(percentage) : calculateGradeMarathi(percentage);
                                    })()}
                                  </b>
                                </td>
                              </tr>


                              {/* Add these fields below your exam name selection */}





                            
                            </>
                          )}
                        </tbody>
                      </table>



                    ) : (
                      <p style={{ fontSize: '18px' , textAlign:'center', marginTop:'20px',  color:'red'}}>{language === "English" ? "! No result available please fill marks." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}


                    
<p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <>{language === "English" ? "Attendance : " : "हजेरी : "}</>
  <input
    type="text"
    placeholder="e.g. 182/80"
    value={attendance}
    onChange={(e) => setAttendance(e.target.value)}
    style={{ width:'90px', border:'none' }}
  />
</p>

<p style={{ display: "flex", alignItems: "center", gap: "10px" , marginTop:'-15px'}}>
  <>{language === "English" ? "Teacher's Remark : " : "शिक्षकांची टिप्पणी : "}</>
  <textarea
    placeholder={language === "English" ? "Enter remark..." : "टिप्पणी प्रविष्ट करा..."}
    value={remark}
    onChange={(e) => setRemark(e.target.value)}
      style={{ width:'410px', border:'none' }}
  />
</p>

<p style={{ display: "flex", alignItems: "center", gap: "10px" , marginTop:'-15px'}}>
  <>{language === "English" ? "Date of Issue : " : "जारी करण्याची तारीख : "}</>
  <input
    type="date"
    value={dateOfIssue}
    onChange={(e) => setDateOfIssue(e.target.value)}
      style={{ width:'130px', border:'none' }}
  />
</p>



                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return total + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                       

  <b>
              {(() => {
                const filteredSubjects = subjectSequence.filter(subject => {
                  const grades = selectedStudentResults?.results?.[subject] || {};
                  return grades.obtainMarks;
                });
                const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                  const grades = selectedStudentResults?.results?.[subject] || {};
                  return total + (grades.outOf || 0);
                }, 0);
                const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                  const grades = selectedStudentResults?.results?.[subject] || {};
                  return total + (grades.obtainMarks || 0);
                }, 0);
                return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
              })()}
            </b>


                        </p>
                      </div>
                    </div>

                    {selectedStudentResults && selectedStudentResults.results ? (
  <div>
    <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
      {/* Your table code here */}
    </table>
    {selectedStudentResults.results.remark && (
      <div style={{ marginTop: "10px" }}>
        <p>
          <strong>
            {language === "English" ? "Remark : " : "टिप्पणी : "} 
            {selectedStudentResults.results.remark}
          </strong>
        </p>
      </div>
    )}
  </div>
) : (
  <p style={{ fontSize: '18px' , textAlign:'center', marginTop:'20px',  color:'red'}}>
    {language === "English" ? "! No result available please fill marks." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
  </p>
)}

                    <div
                      className="grad"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's signature" : "पालकांची सही"}
                      </label>
                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
                      </label>

                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>

         
    <Button 
      className="btn btn-primary"
      onClick={saveStudentDetails}
      disabled={!selectedExamName || !classValue || !division}
    >
      {language === "English" ? "Save Details" : "तपशील जतन करा"}
    </Button>



            <Button variant="secondary" onClick={handleCloseModal}>
              {language === "English" ? " Close " : "Close करा"}
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              {language === "English" ? "Print" : "Print करा"}
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default PrelimsResult;
